import React from 'react';
import {FieldControl} from 'react-reactive-form';
import {OptionFilterProps} from './types';
import styles from './OptionFilter.module.scss';
import {Flex, Select, Typography} from 'antd';
import {BaseOptionType} from 'antd/es/select';
export const optionStyles = styles;

export const OptionFilter: React.FC<OptionFilterProps<any>> = <T,>(props: OptionFilterProps<T>) => {
  const {label: filterLabel, control, options, isHorizontal, order} = props;

  if (!options || (options.length <= 1 && props.label !== 'Platform')) {
    return <></>;
  }

  // Normalize options to ensure they have proper structure
  const normalizedOptions = options
    .map((option) => {
      if (typeof option === 'string' || typeof option === 'number') {
        return {label: option, value: option};
      }
      if (option && typeof option === 'object' && !('label' in option || 'value' in option)) {
        return {label: String(option), value: option};
      }
      return option;
    })
    .filter(Boolean);

  interface HandleOnChangeParams {
    value: string[];
    currentValue: {name: string; email: string}[];
    filterLabel: string;
    setValue: (value: any) => void;
    option: BaseOptionType[];
  }

  /*
    antd can only handle a string value
    so not to change the search algorithm I've added this handler
  */
  const handleOnChange = ({value, filterLabel, setValue, option}: HandleOnChangeParams) => {
    if (
      (filterLabel === 'Steward' || filterLabel === 'HEDS Lead' || filterLabel === 'Creator') &&
      option &&
      option.length > 0
    ) {
      setValue(option);
      return;
    }

    if (!value || value.length === 0) {
      setValue([]);
      return;
    }

    if (filterLabel !== 'Steward' && filterLabel !== 'HEDS Lead' && filterLabel !== 'Creator') {
      setValue(value);
    }
  };

  return (
    <Flex style={{width: isHorizontal ? '268px' : '100%', order}}>
      <FieldControl
        control={control}
        strict={false}
        render={({setValue, value: currentValue}) => (
          <Select
            value={Array.isArray(currentValue) ? currentValue : []}
            options={normalizedOptions}
            onChange={(value, option) => {
              try {
                handleOnChange({
                  value: Array.isArray(value) ? value : [],
                  currentValue,
                  filterLabel,
                  setValue,
                  option: Array.isArray(option) ? option : [],
                });
              } catch (e) {
                setValue([]);
              }
            }}
            filterOption={(input, option) => {
              if (!input) return true;
              const search = input.toLowerCase();
              const labelMatch = (option?.label?.toString() ?? '').toLowerCase().includes(search);
              // Also search by isid/id for HEDS Lead and Creator filters
              const opt = option as any;
              const idMatch = ((opt?.isid ?? opt?.id) || '').toString().toLowerCase().includes(search);
              return labelMatch || idMatch;
            }}
            mode="multiple"
            allowClear
            placeholder={<Typography.Text>{filterLabel}</Typography.Text>}
            maxTagCount="responsive"
            maxTagTextLength={30}
            style={{width: '100%'}}
          />
        )}
      />
    </Flex>
  );
};
